'use strict';


var parse = require('./parser-sync');
var pack = require('./packer-sync');


exports.read = function(buffer, options) {

  return parse(buffer, options || {});
};

exports.write = function(png) {

  return pack(png);
};



/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/~/pngjs-nozlib/lib/png-sync.js
 ** module id = 1115
 ** module chunks = 0
 **/